module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-457.0231c8a.woff2";